import { termsPolicyAndContactConstants } from "../constants/termsPolicyAndContactConstants";

const initialState = {
  sending: false,
  sended: false,
  error: "",
  addedStaticPage: {},
  staticPageList: {},
  receivingDetails: false,
  receivedDetails: false,
  fetchedDetails: false,
  fetchingDetails: false,
  staticPageDetails: {},
};

export default function termsPolicyAndContactReducer(
  state = initialState,
  action
) {
  switch (action.type) {
    case termsPolicyAndContactConstants.ADD_STATIC_PAGE_REQUEST:
      return {
        ...state,
        sending: true,
        sended: false
      };
    case termsPolicyAndContactConstants.ADD_STATIC_PAGE_SUCCESS:
      return {
        ...state,
        sending: false,
        sended: true,
        addedStaticPage: action.data,
        error: ""
      };
    case termsPolicyAndContactConstants.ADD_STATIC_PAGE_FAILURE:
      return {
        ...state,
        sended: false,
        sending: false,
        error: action.error
      };
    case termsPolicyAndContactConstants.GET_STATIC_PAGE_REQUEST:
      return {
        ...state,
        receivedDetails: false,
        receivingDetails: true
      };
    case termsPolicyAndContactConstants.GET_STATIC_PAGE_SUCCESS:
      return {
        ...state,
        receivedDetails: true,
        receivingDetails: false,
        staticPageList: action.data.data
      };
    case termsPolicyAndContactConstants.GET_STATIC_PAGE_FAILURE:
      return {
        ...state,
        receivingDetails: false,
        receivedDetails: false,
        error: action.error
      };
    case termsPolicyAndContactConstants.GET_BECOMEAPARTNER_REQUEST:
      return {
        ...state,
        receivedDetails: false,
        receivingDetails: true
      };
    case termsPolicyAndContactConstants.GET_BECOMEAPARTNER_SUCCESS:        
      return {
        ...state,
        receivedDetails: true,
        receivingDetails: false,
        becomePartnerDetails: action.data.data.becomeAPartner,
        french_becomePartnerDetails: action.data.data.french_becomeAPartner
      };
    case termsPolicyAndContactConstants.GET_BECOMEAPARTNER_FAILURE:    
      return {
        ...state,
        receivingDetails: false,
        receivedDetails: false,
        error: action.error
      };
    case termsPolicyAndContactConstants.GET_STATIC_PAGE_DETAILS_REQUEST:
      return {
        ...state,
        fetchedDetails: false,
        fetchingDetails: true
      };
    case termsPolicyAndContactConstants.GET_STATIC_PAGE_DETAILS_SUCCESS:
      return {
        ...state,
        fetchedDetails: true,
        fetchingDetails: false,
        staticPageDetails: action.data.data
      };
    case termsPolicyAndContactConstants.GET_STATIC_PAGE_DETAILS_FAILURE:
      return {
        ...state,
        fetchingDetails: false,
        fetchedDetails: false,
        error: action.error
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/app/redux/reducers/termsPolicyAndContactReducer.js